var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", [
    _c(
      "div",
      { staticClass: "filter-list-wrapper" },
      [
        _c("transition", { attrs: { name: "filter-transition" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.open,
                  expression: "open"
                }
              ],
              ref: "filterlist",
              staticClass: "filter-list",
              class: {
                "filter-list--offer-counter-fixed": _vm.fixCounter,
                "filter-list--offer-counter-float": _vm.floatCounter
              }
            },
            [
              _c("div", { staticClass: "filter-list__header" }, [
                _c("div", { staticClass: "filter-list__header__icon" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/img/icons/icon-filter-header.svg"),
                      alt: ""
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "h2",
                  { staticClass: "filter-list__header__text" },
                  [
                    _c("offer-counter", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.open,
                          expression: "open"
                        }
                      ]
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "filter-list__header__btn",
                    on: {
                      click: function($event) {
                        _vm.open = false
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 27.15 27.15"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M16.26,13.57,26.59,3.24A1.9,1.9,0,0,0,23.9.56L13.57,10.89,3.24.56A1.88,1.88,0,0,0,.56.56a1.88,1.88,0,0,0,0,2.68L10.89,13.57.56,23.9a1.9,1.9,0,1,0,2.68,2.69L13.57,16.26,23.9,26.59a1.93,1.93,0,0,0,1.35.56,1.91,1.91,0,0,0,1.34-3.25Z"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-list__nav" },
                _vm._l(_vm.tabs, function(tab, tabKey) {
                  return _c("button", {
                    key: tabKey,
                    class: { current: _vm.currentTab == tabKey },
                    domProps: { textContent: _vm._s(tab) },
                    on: {
                      click: function($event) {
                        _vm.currentTab = tabKey
                      }
                    }
                  })
                })
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "filter-list__wrapper",
                  class: { "filter-list__wrapper--disable": false }
                },
                [_vm._t("default")],
                2
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm.ready && !_vm.open
          ? _c(
              "div",
              {
                staticClass: "filter-fab",
                on: {
                  click: function($event) {
                    _vm.open = !_vm.open
                  }
                }
              },
              [
                _vm.toolTip
                  ? _c("div", { staticClass: "filter-fab__text" }, [
                      _c("span", {
                        domProps: { textContent: _vm._s(_vm.toolTip) }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "filter-fab__icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 35.97 29.92"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M22.15,2.92a4.43,4.43,0,0,0-8.34,0H0v3H13.8a4.43,4.43,0,0,0,8.38,0H36v-3ZM18,7.34a2.89,2.89,0,1,1,2.89-2.88A2.88,2.88,0,0,1,18,7.34Z"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d:
                            "M28.48,10.5a4.44,4.44,0,0,0-4.17,2.94H0v3H24.3a4.43,4.43,0,0,0,8.38,0H36v-3H32.65A4.45,4.45,0,0,0,28.48,10.5Zm0,7.34A2.89,2.89,0,1,1,31.37,15,2.88,2.88,0,0,1,28.48,17.84Z"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d:
                            "M7.48,21a4.44,4.44,0,0,0-4.17,2.94H0v3H3.3a4.43,4.43,0,0,0,8.38,0H36v-3H11.65A4.45,4.45,0,0,0,7.48,21Zm0,7.34a2.89,2.89,0,1,1,2.89-2.88A2.88,2.88,0,0,1,7.48,28.34Z"
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c460c0c", { render: render, staticRenderFns: staticRenderFns })
  }
}